module.exports = __webpack_public_path__ + "static/media/curved14.34ecccd6.jpg";